export const FETCH_SETTING_WPS_CONFIG = "FETCH_SETTING_WPS_CONFIG";
export const FETCH_PAYROLL_LIST_FOR_WPS = "FETCH_PAYROLL_LIST_FOR_WPS";
export const FETCH_PAYROLL_LIST_FOR_WPS_SAVE_IN_EXCEL =
  "FETCH_PAYROLL_LIST_FOR_WPS_SAVE_IN_EXCEL";
export const FETCH_PAY_IN_GROUP_MASTER = "FETCH_PAY_IN_GROUP_MASTER";
